module.exports = __webpack_public_path__ + "02_short_black.cf902c2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/02_short_black.png
// module id = Fv94
// module chunks = 0